import * as React from 'react';
import { Path } from 'react-native-svg';

function Tears() {
  return (
    <>
      <Path
        d="M91.61 96.59c.19 6.29-2.29 12.48-1.85 18.76.1 1.49.58 3.23 2 3.73a2.73 2.73 0 003.17-1.51 5 5 0 00.06-3.74c-.39-1.22-1-2.34-1.52-3.52a14.84 14.84 0 01-.85-8.61 13.86 13.86 0 00.64-4.54c-.16-1.17-1.17-2.83-2.52-2.7a2.55 2.55 0 01.87 2.13z"
        fill="#39bcde"
        stroke="#047e89"
        strokeMiterlimit={10}
        strokeWidth={0.25}
      />
      <Path
        d="M94 113.32a3.36 3.36 0 01-.83 3.14c-.28.28-.63.55-.69.94a.9.9 0 001.09.87 1.44 1.44 0 001-1.15 4.22 4.22 0 00-.06-1.62l-.19-1.15a2.12 2.12 0 00-.33-1"
        fill="#fff"
      />
      <Path
        d="M45.55 92.38c-2 4.35-2.12 9.43-4.3 13.7-.52 1-1.37 2.09-2.51 2a2.09 2.09 0 01-1.77-2 3.88 3.88 0 011.08-2.65c.63-.73 1.42-1.32 2.12-2a11.31 11.31 0 003.16-5.78 10.72 10.72 0 01.91-3.37c.46-.77 1.67-1.63 2.57-1.14a1.93 1.93 0 00-1.26 1.24z"
        fill="#39bcde"
        stroke="#047e89"
        strokeMiterlimit={10}
        strokeWidth={0.19}
      />
      <Path
        d="M38.91 103.4a2.54 2.54 0 00-.35 2.45 1.41 1.41 0 01.19.86.68.68 0 01-1 .29 1.11 1.11 0 01-.37-1.12 3.22 3.22 0 01.52-1.11l.48-.75a1.5 1.5 0 01.52-.58"
        fill="#fff"
      />
    </>
  );
}

export default Tears;
